import React from 'react';
import { Icon, Button } from '@common/components';

export const PrevNextButtons = (props: {
  onNext: () => void;
  onPrev: () => void;
  disablePrev?: boolean;
  disableNext?: boolean;
}) => (
  <div className="wk-next-prev-buttons">
    <Button
      kind="link"
      className="wk-prev-button"
      onClick={props.onPrev}
      disabled={props.disablePrev}
    >
      <Icon icon="chevronLeft" />
    </Button>
    <Button
      kind="link"
      className="wk-next-button"
      onClick={props.onNext}
      disabled={props.disableNext}
    >
      <Icon icon="chevronRight" />
    </Button>
    <style jsx>
      {`
        .wk-next-prev-buttons :global(.wk-prev-button),
        .wk-next-prev-buttons :global(.wk-next-button) {
          padding: 0;
          height: 24px;
          width: 24px;
        }
        .wk-next-prev-buttons :global(.wk-next-button) {
          margin-left: 16px;
        }
      `}
    </style>
  </div>
);
